import * as React from 'react'
export function ThumbUp({ title = 'ThumbUp', className, variation, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
      className={className}
      data-variation={variation}
      {...props}
    >
      <title>{title}</title>
      <path
        d="M4.08333 14.0833H2.08333C1.72971 14.0833 1.39057 13.9429 1.14052 13.6928C0.890476 13.4428 0.75 13.1036 0.75 12.75V8.08333C0.75 7.72971 0.890476 7.39057 1.14052 7.14052C1.39057 6.89048 1.72971 6.75 2.08333 6.75H4.08333M8.75 5.41667V2.75C8.75 2.21957 8.53929 1.71086 8.16421 1.33579C7.78914 0.960714 7.28043 0.75 6.75 0.75L4.08333 6.75V14.0833H11.6033C11.9249 14.087 12.2369 13.9743 12.4819 13.766C12.727 13.5577 12.8885 13.2679 12.9367 12.95L13.8567 6.95C13.8857 6.7589 13.8728 6.56379 13.8189 6.37817C13.765 6.19255 13.6714 6.02086 13.5446 5.87501C13.4177 5.72916 13.2607 5.61262 13.0844 5.53348C12.908 5.45434 12.7166 5.41448 12.5233 5.41667H8.75Z"
        stroke="#5C708A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default ThumbUp
